import React from "react";
import about from "../../images/about_us_about.png";
import mission from "../../images/about_us_mission.png";
import foundingStory from "../../images/about_us_founding_story.png";
import styles from "./AboutUs.module.scss";

const AboutUs = () => {
  return (
    <>
      <section className={styles.aboutUs}>
        <div className={`${styles.aboutUsChild}`} id={styles.about}>
          <div className={styles.childImage}>
            <img src={about} alt="about us" />
          </div>
          <div className={styles.childContent}>
            <h1>About Us</h1>
            <p>
              Qreativs is a platform for all creative professionals and new age
              businesses to step into the new world of creative work and
              networking. Connect, collaborate, and grow with creatives, mentors
              and businesses. Get advice and insights from others in the
              creative industry. Find creatives to collaborate with and be
              discovered by businesses to work on projects.
            </p>
            <p>
              Businesses can find the right creatives to bring their vision to
              life. A new age community where creatives and brands build
              together openly and effortlessly. Join Qreativs to connect, create
              and collaborate with creatives around you.
            </p>
          </div>
        </div>
        <div className={`${styles.aboutUsChild}`} id="mission">
          <div className={styles.childContent}>
            <h1>Our mission</h1>
            <p>
              Our mission is to empower and grow the creative community with the
              help of networking and seamlessly finding projects by businesses.
              Qreativs is a community where everyone is welcome to express their
              ideas and recognize the irreplaceable value of creativity in an
              increasingly corporate world.
            </p>
            <p>
              It is a social and professional bridge that connects diverse
              creative minds with relevant work and like-minded collaborators
              without geographical restrictions. We are here to create a new way
              of creative networking and finding work opportunities for
              creatives and businesses.
            </p>
          </div>
          <div className={styles.childImage}>
            <img src={mission} alt="our mission" />
          </div>
        </div>
        {/* <div className={`${styles.aboutUsChild}`} id={styles.foundingStory}>
          <div className={styles.childImage}>
            <img src={foundingStory} />
          </div>
          <div className={styles.childContent}>
            <h1>Founding story</h1>
            <p>
              Egestas fringilla aliquam leo, habitasse arcu varius lorem elit.
              Neque pellentesque donec et tellus ac varius tortor, bibendum.
              Nulla felis ac turpis at amet. Purus malesuada placerat arcu at
              enim elit in accumsan.
            </p>
          </div>
        </div> */}
      </section>
    </>
  );
};

export default AboutUs;
